import React, { useContext, useEffect } from 'react';
import { Button, Form, Spinner, Table } from 'react-bootstrap';
import { MdFileCopy, MdEditSquare, MdDelete } from 'react-icons/md'
import { useNavigate } from 'react-router-dom';
import Zoom from 'react-medium-image-zoom';

import { get_themes_data } from '../../../../Controller/actions';
import { NewContext } from '../../../../Context/NewContext';
import PaginationCmp from '../../../../Components/Pagination/PaginationCmp';
import PopOver from '../../../../Components/Popover/PopOver';
import { Header } from '../../../../Components/Header';
import { THead } from '../../../../Components/Table';

import './themes.css';

export const Themes = ({ title }) => {
    const navigate = useNavigate();
    const { filterDropdown, currentTableData, setCurrentTableData, currentPage, setCurrentPage, totalPage, setTotalPage, perPage, setPerPage, isLoading, setIsLoading, confirmationModalShow, setConfirmationModalShow, deleteUpdateTag, setDeleteUpdateItem, search, setDeleteUpdateYes, checkedValues, handleCopyData, handleCheckboxChange } = useContext(NewContext);
    const simpleFields = ["Id", "Name", "Category", "Tag", "Country", "Region", "Preview", "UserHit", "StartDate", "EndDate"];
    const dropdownFields = ["Premium", "Animated", "AvaiableDiffKey", "Top", "Latest", "Hot", "Active"];

    const totalFields = simpleFields.length + dropdownFields.length + 2;

    let handleSwitch = (e) => {
        setDeleteUpdateYes("updatethemes");
        setDeleteUpdateItem({ id: e.target.id, [e.target.name]: !e.target.checked ? false : true });
        setConfirmationModalShow(!confirmationModalShow)
    };

    const getThemesData = async (_currentPage = 1) => {
        setIsLoading(true);
        try {
            const getThemes = await get_themes_data(_currentPage, perPage, search, filterDropdown);
            if (getThemes) {
                const { status, data, currentPage, perPage, totalPage, isLoadMore } = getThemes;
                if (status) {
                    // console.log(data);
                    setCurrentTableData(data);
                    setCurrentPage(currentPage);
                    setPerPage(perPage);
                    setTotalPage(totalPage);
                } else {
                    // toast.error(message);
                    setCurrentTableData([]);
                }
            }
            setIsLoading(false);
        } catch (error) {
            console.error(error);
        }
    };

    useEffect(() => {
        getThemesData(currentPage);
    }, [deleteUpdateTag, search, filterDropdown]);

    useEffect(() => {
        document.title = `Emoji Keyboard | ${title}`
    }, []);

    return (
        <div className='table-header-main ms-auto p-3'>
            <Header title={`Themes`} previewLink={`/preview`} addLink={`/themesform`} deleteUpdateTag={"alldeletethemes"} isLoadMoreShow={true} />
            <Table striped bordered hover responsive>
                <THead
                    simpleFields={simpleFields}
                    dropdownFields={dropdownFields}
                />
                <tbody>
                    {
                        isLoading ?
                            <tr>
                                <td colSpan={totalFields} className='py-5'>
                                    <div className="d-flex justify-content-center align-items-center">
                                        <Spinner animation="border" />
                                    </div>
                                </td>
                            </tr>
                            : currentTableData?.length === 0 ?
                                <tr>
                                    <td colSpan={totalFields} className='py-5 bg-light'>
                                        <div className="d-flex justify-content-center align-items-center">
                                            No Data Found
                                        </div>
                                    </td>
                                </tr>
                                : currentTableData?.map((_ele, i) => (
                                    <tr key={i} className="align-middle">
                                        <td>
                                            <Form.Check
                                                type={'checkbox'}
                                                id={`theme-${_ele._id}`}
                                                value={`${_ele._id}`}
                                                checked={checkedValues.includes(`${_ele._id}`)}
                                                onChange={() => handleCheckboxChange(`${_ele._id}`)}
                                            />
                                        </td>
                                        <td>{perPage * (currentPage - 1) + (i + 1)}</td>
                                        <td className={`text-truncate pe-4 position-relative`} style={{ maxWidth: "100px" }}>
                                            {
                                                _ele.name ?
                                                    <>
                                                        <span>{_ele.name}</span>
                                                        <PopOver placement={"right"} message={_ele.name} />
                                                    </> : <span className='text-muted'>None</span>
                                            }
                                        </td>
                                        <td className={`text-truncate pe-4 position-relative`} style={{ maxWidth: "100px" }}>
                                            {
                                                _ele.themeCategory && _ele.themeCategory?.length !== 0 ?
                                                    <>
                                                        {_ele.themeCategory?.map((_theme_ele, key) => key === _ele.themeCategory?.length - 1 ? _theme_ele : `${_theme_ele}, `)}
                                                        <PopOver placement={"right"} data={_ele.themeCategory} />
                                                    </> : <span className='text-muted'>None</span>
                                            }
                                        </td>
                                        <td className={`text-truncate pe-4 position-relative`} style={{ maxWidth: "100px" }}>
                                            {
                                                _ele.themeTag && _ele.themeTag?.length !== 0 ?
                                                    <>
                                                        {_ele.themeTag?.map((_theme_ele, key) => key === _ele.themeTag?.length - 1 ? _theme_ele : `${_theme_ele}, `)}
                                                        <PopOver placement={"right"} data={_ele.themeTag} />
                                                    </> : <span className='text-muted'>None</span>
                                            }
                                        </td>
                                        <td className={`text-truncate pe-4 position-relative`} style={{ maxWidth: "100px" }}>
                                            {
                                                _ele.country && _ele.country?.length !== 0 ?
                                                    <>
                                                        {_ele.country?.map((_theme_ele, key) => key === _ele.country?.length - 1 ? _theme_ele : `${_theme_ele}, `)}
                                                        <PopOver placement={"right"} data={_ele.country} />
                                                    </> : <span className='text-muted'>None</span>
                                            }
                                        </td>
                                        <td className={`text-truncate pe-4 position-relative`} style={{ maxWidth: "100px" }}>
                                            {
                                                _ele.region && _ele.region?.length !== 0 ?
                                                    <>
                                                        {_ele.region?.map((_theme_ele, key) => key === _ele.region?.length - 1 ? _theme_ele : `${_theme_ele}, `)}
                                                        <PopOver placement={"right"} data={_ele.region} />
                                                    </> : <span className='text-muted'>None</span>
                                            }
                                        </td>
                                        <td>
                                            <div className='imgTd position-relative'>
                                                <img className='table-preview_img position-absolute d-block' src={`${_ele.smallPreview ? `${_ele.smallPreview}` : `../../../assets/images/no-image.png`}`} alt={_ele.name} />
                                                <Zoom>
                                                    <img className='table-preview_img d-block' src={`${_ele.smallPreview ? `${_ele.smallPreview}` : `../../../assets/images/no-image.png`}`} alt={_ele.name} />
                                                </Zoom>
                                            </div>
                                        </td>
                                        <td>{_ele.userHit}</td>
                                        <td className='text-nowrap'>{_ele.showStartDate ? _ele.showStartDate?.split('T')[0] : <span className='text-muted'>None</span>}</td>
                                        <td className='text-nowrap'>{_ele.showEndDate ? _ele.showEndDate?.split('T')[0] : <span className='text-muted'>None</span>}</td>
                                        {
                                            ["isPremium", "isAnimated", "isAvaiableDiffKey", "isTop", "isLatest", "isHot", "isActive"]?.map((_is_ele, i) => (
                                                <td key={i}>
                                                    {/* <Badge bg={_is_ele ? "success" : "danger"} className="fw-normal">
                                                        {_is_ele ? `On` : `Off`}
                                                    </Badge> */}
                                                    <Form.Check type="switch" id={_ele._id} name={_is_ele} onChange={handleSwitch} checked={_ele[_is_ele]} role="button" />
                                                </td>
                                            ))
                                        }
                                        <td>
                                            <div className='d-flex action-btns'>
                                                {/* <TooltipCmp placement={`top`} tooltipText={copyText}> */}
                                                <Button className='px-2 me-2' variant="info" onClick={() => handleCopyData(_ele)}>
                                                    <MdFileCopy color='black' size={"18px"} />
                                                </Button>
                                                {/* </TooltipCmp> */}

                                                {/* <TooltipCmp placement={`top`} tooltipText={`Edit`}> */}
                                                <Button className='px-2 me-2' variant="warning" onClick={() => navigate(`/themesform`, { state: _ele })}>
                                                    <MdEditSquare color='black' size={"18px"} />
                                                </Button>
                                                {/* </TooltipCmp> */}

                                                {/* <TooltipCmp placement={`top`} tooltipText={`Delete`}> */}
                                                <Button className='px-2 me-2' variant="danger" onClick={() => { setDeleteUpdateYes("deletethemes"); setDeleteUpdateItem({ id: _ele._id, name: _ele.name }); setConfirmationModalShow(!confirmationModalShow) }}>
                                                    <MdDelete color='black' size={"18px"} />
                                                </Button>
                                                {/* </TooltipCmp> */}
                                            </div>
                                        </td>
                                    </tr>
                                ))
                    }
                </tbody>
            </Table >
            <div className={`table-pagination d-flex justify-content-center justify-content-xl-end ${currentTableData?.length > 0 ? 'd-block' : 'd-none'}`}>
                <PaginationCmp
                    currentPage={currentPage}
                    totalPage={totalPage}
                    getData={getThemesData}
                />
            </div>
        </div >
    )
};

Themes.defaultProps = {
    title: "Themes"
};

export default Themes;
